module.exports = __webpack_public_path__ + "static/media/confirm__title.9d7037ce.png";